#import "@/components/common/StoryPreviewFragment.gql"

fragment StoryListFragment on storyList_Entry {
  typeHandle
  heading
  stories {
    ...StoryPreviewFragment
  }
}
